import React from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  Chip,
  Stack
} from "@mui/material";
import {
  Add,
  Remove,
  FormatBold,
  ColorLens
} from "@mui/icons-material";

const FontControls = ({
  font,
  fontSize,
  fontWeight,
  color,
  onFontChange,
  onFontSizeChange,
  onFontWeightChange,
  onOpenColorPicker,
  fonts = []
}) => {
  return (
    <Stack spacing={3}>
      <Box
        display="flex"
        gap={2}
        alignItems="center"
        flexDirection={{ xs: "column", sm: "row" }}
      >
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Fuente</InputLabel>
          <Select
            value={font || "Open Sans"}
            onChange={(e) => onFontChange(e.target.value)}
            label="Fuente"
            sx={{ borderRadius: "16px" }}
            renderValue={(value) => (
              <span style={{ fontFamily: value }}>
                {fonts.find((f) => f.value === value)?.label ?? value}
              </span>
            )}
          >
            {fonts.map((f) => (
              <MenuItem key={f.value} value={f.value} sx={{ fontFamily: f.value }}>
                {f.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body2" color="text.secondary">
            Tamaño
          </Typography>
          <Tooltip title="Disminuir tamaño">
            <IconButton
              size="small"
              onClick={() => onFontSizeChange(Math.max(8, (fontSize || 12) - 1))}
              sx={{
                bgcolor: "#e5e7eb",
                borderRadius: "50%",
                "&:hover": { bgcolor: "#d1d5db" },
              }}
            >
              <Remove sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
          <Chip label={fontSize || 12} size="small" sx={{ minWidth: 40 }} />
          <Tooltip title="Aumentar tamaño">
            <IconButton
              size="small"
              onClick={() => onFontSizeChange((fontSize || 12) + 1)}
              sx={{
                bgcolor: "#e5e7eb",
                borderRadius: "50%",
                "&:hover": { bgcolor: "#d1d5db" },
              }}
            >
              <Add sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        </Box>

        <Tooltip title="Alternar negrita">
          <IconButton
            size="small"
            onClick={() => onFontWeightChange(fontWeight === "bold" ? "normal" : "bold")}
            sx={{
              bgcolor: fontWeight === "bold" ? "#1976d2" : "#e5e7eb",
              color: fontWeight === "bold" ? "white" : "#374151",
              borderRadius: "50%",
              "&:hover": {
                bgcolor: fontWeight === "bold" ? "#1565c0" : "#d1d5db",
              },
            }}
          >
            <FormatBold sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>

        <Tooltip title="Seleccionar color">
          <IconButton
            size="small"
            onClick={onOpenColorPicker}
            sx={{
              bgcolor: color || "#000000",
              borderRadius: "50%",
              border: "1px solid #d1d5db",
              width: 32,
              height: 32,
            }}
          >
            <ColorLens sx={{ fontSize: 16, color: "white" }} />
          </IconButton>
        </Tooltip>
      </Box>
    </Stack>
  );
};

export default FontControls;
